export const BETS_CHUNK_DAYS = 7;
export const BETS_INITIAL_CHUNK_OVERLAP = 3;
